import { render, staticRenderFns } from "./detail-site.vue?vue&type=template&id=bc3e5108&scoped=true"
import script from "./detail-site.vue?vue&type=script&lang=js"
export * from "./detail-site.vue?vue&type=script&lang=js"
import style0 from "./detail-site.vue?vue&type=style&index=0&id=bc3e5108&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3e5108",
  null
  
)

export default component.exports